import React from "react"
import CaseBlockMultiSelect from "./components/caseBlockMultiSelect";
import { CaseBlockNumberInput } from "./components/caseBlockNumberInput";
import CaseBlockSelect from "./components/caseBlockSelect";
import DeleteIcon from '../../assets/delete.svg'
import InfoIcon from '../../assets/info.svg'
import { Tooltip } from "@material-ui/core";

export class CaseBlock extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isHovering: false
    }
  }

  render() {
    // Curate Description
    let description = ""
    let character = " or "
    if (this.props.obj.filterType !== 'filter') {
      if (this.props.obj.isAnd) {
        character = " and "
      }
      if (this.props.obj.filters.length === 0) {
        description = ""
      }
      else {
        description = `(${this.props.obj.filters.map(item => item.label).join(character)})`;
      }
    }

    return (
      <div
        customobjdata={JSON.stringify(this.props.obj)}
        id={this.props.obj.filterType === 'filter' ? 'filter-block' : "box-case-block"}
        key={this.props.obj.id}
        onDrop={(e) => this.props.onDrop(e)}
        onDragOver={(e) => this.props.onDragOver(e)}
        draggable="true"
        onDragStart={(e) => { this.props.drag(e) }}
        style={{
          width: '100%',
          backgroundColor:
            'rgba(0, 24, 64, 0.2)',
          padding: '1%',
          marginBottom: 5,
          borderRadius: 5,
          position: 'relative'
        }}
        // Hover Functionality
        onMouseEnter={() => { this.setState({ isHovering: true }) }}
        onMouseLeave={() => { this.setState({ isHovering: false }) }}
      >
        {/* Display for Case Block */}
        {this.props.obj.filterType !== 'filter' ? this.props.obj.label : null}
        {/* Display for filters single select */}
        {this.props.obj.filterType === 'filter' ? (
          <React.Fragment>
            {/* Map Out Radio & Select*/}
            {this.props.obj.type === 'radio' || this.props.obj.type === 'select' || this.props.obj.type === 'select_nonString' || this.props.obj.type === 'select_inject' ? (
              <CaseBlockSelect
                label={this.props.obj.label}
                filterId={this.props.obj.id}
                filterData={this.props.obj.data}
                onSelectedData={this.props.onSelectedData}
                selectedData={this.props.obj.selectedData}
              />
            ) : (null)}
            {/* Display Filters for Muliselect */}
            {this.props.obj.type === 'multiSelect' || this.props.obj.type === 'multiSelect_agg' ? (
              <CaseBlockMultiSelect
                label={this.props.obj.label}
                filterId={this.props.obj.id}
                filterData={this.props.obj.data}
                onSelectedData={this.props.onSelectedData}
                selectedData={this.props.obj.selectedData} />
            ) : (null)}
            {/* Display Filter for number input */}
            {this.props.obj.type === 'number' ? (
              <CaseBlockNumberInput
                label={this.props.obj.label}
                filterId={this.props.obj.id}
                filterData={this.props.obj.data}
                onSelectedData={this.props.onSelectedData}
                selectedData={this.props.obj.selectedData}
              />
            ) : (null)}
          </React.Fragment>
        ) : (null)}
        {this.props.obj.filterType !== 'filter' && this.props.obj.filters.map((obj, idx) => {
          return (
            <CaseBlock
            onFilterDelete={this.props.onFilterDelete}
              onSelectedData={this.props.onSelectedData}
              key={obj.id + idx} obj={obj} drag={this.props.drag}
              onDrop={this.props.onDrop} onDragOver={this.props.onDragOver} />
          )
        })}
        {/* Display Delete Button on Hover */}
        {this.state.isHovering && (
          <div style={{ position: 'absolute', top: 5, right: 5 }}>
            <div style={{ display: 'flex' }}>
              <Tooltip title="Delete Filter">
                <button
                  onClick={()=>{this.props.onFilterDelete(this.props.obj.id)}}
                  style={{ borderRadius: 10, opacity: '0.6' }}
                ><img src={DeleteIcon} style={{ height: 25, width: 25 }}></img></button>
              </Tooltip>
              {/* <Tooltip title="Filter Info">
              <button style={{borderRadius:10, opacity:'0.8'}}><img src={InfoIcon} style={{ height: 35, width: 35 }}></img></button>
            </Tooltip> */}
            </div>
          </div>
        )}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/views/AudienceBuilder/components/dragAndDrop/caseBlock.jsx